export const logoChatGPT = require("./chatGPT.png");
export const NotFound = require("./notfound.png");
export const Logo = require("./logo.png");
